import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'integrations';

export default {
  state: {
    all: [],
    current: null
  },

  mutations: {
    setAllIntegrations(state, integrations) {
      state.all = integrations;
    },

    addIntegration(state, integration) {
      state.all.push(integration);
    },

    setCurrentIntegration(state, integration) {
      state.current = integration;
    }
  },

  actions: {
    fetchIntegrations({ commit }) {
      return api
        .instance()
        .get(`${apiVersion}/${source}`, { params: { team_id: auth.teamId() } })
        .then((resp) => {
          commit(
            "setAllIntegrations",
            _.map(resp.data.data, (integration) => integration.attributes)
          );
        })
        .catch((err) => console.error("Failed to fetch integrations", err));
    },

    createIntegration({ commit }, params) {
      const integration = params.integration;
      integration.team_id = auth.teamId();

      return api
        .instance()
        .post(`${apiVersion}/${source}`, integration)
        .then((resp) => {
          commit("addIntegration", resp.data.data.attributes);
          params.callback(null, resp);
        })
        .catch((err) => {
          params.callback(err, null);
        });
    },

    changeCurrentIntegration({ commit, state }, integrationId) {
      const integration = _.findWhere(state.all, { id: parseInt(integrationId) });
      commit("setCurrentIntegration", integration);

      return integration;
    }
  }
};
